import React from 'react';
import PropTypes from 'prop-types';

const Format = ({ className, children, ...props }) => (
  <span className={`Format ${className}`.trim()} {...props}>
    {children}
  </span>
);

Format.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
};

Format.defaultProps = {
  children: null,
  className: '',
};

export default Format;
